const CREDENTIAL_ERROR_CODES = [
  'auth/wrong-password',
  'auth/user-not-found',
  'auth/invalid-credential',
  'auth/invalid-login-credentials'
];

export default function getLoginErrors(error) {
  if (error.code === 'auth/invalid-email')
    return { email: 'Please enter a valid e-mail' };
  if (error.code === 'auth/user-disabled')
    return { email: 'This account has been disabled' };
  if (error.code === 'auth/too-many-requests')
    return { password: 'Too many attempts, please try again later' };
  if (CREDENTIAL_ERROR_CODES.includes(error.code))
    return { email: true, password: 'Incorrect e-mail or password' };
  return { email: true, password: 'Unable to log in, please try again' };
}
